import { render, staticRenderFns } from "./SyllabusAcceptanceTimeAdminActions.vue?vue&type=template&id=51c65aba&scoped=true&"
import script from "./SyllabusAcceptanceTimeAdminActions.vue?vue&type=script&lang=js&"
export * from "./SyllabusAcceptanceTimeAdminActions.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusAcceptanceTimeAdminActions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SyllabusAcceptanceTimeAdminActions.vue?vue&type=style&index=1&id=51c65aba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c65aba",
  null
  
)

export default component.exports